import { render } from "./Home.vue?vue&type=template&id=0c127be8"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script